module.exports = __webpack_public_path__ + "static/img/empty.f891239.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pserson/empty.png
// module id = 7Fzy
// module chunks = 1